import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./landing.css";
import { NavigationBoxes } from "./NavigationBoxes";
import Card from "react-bootstrap/Card";
import nnSeal from "../Images/navajo_nation_seal.png";
import { selectSignIn } from "../../store/slices/signed-in-slice";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectProfile } from "../../store/slices/profile-slice";
import "../Dashboard/Dashboard.css";
import { Ratio } from "react-bootstrap";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

export const LandingPage = () => {
    const isSignedIn = useSelector(selectSignIn);
    const navigate = useNavigate();
    const profile = useSelector(selectProfile); //returns that state of profile
    const [width, setWidth] = useState(window.innerWidth);

    let data = {
        firstName: profile.firstName ? profile.firstName : "",
        middleName: profile.middleName ? profile.middleName : "",
        lastName: profile.lastName ? profile.lastName : "",
    };

    let { firstName, middleName, lastName } = data;
    const middleInitial = middleName.charAt(0) ? middleName.charAt(0) : "";

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;
    return (
        <>
            <Container fluid className="pt-2 background justify-content-center">
                <Row>
                    <Col xl={12}>
                        <Card>
                            <Card.Body>
                                <Row className="justify-content-center text-center">
                                    <Col xs={12} md={6}>
                                        <Row>
                                            <Col md={2} className="d-flex justify-content-center">
                                                <img
                                                    src={nnSeal}
                                                    alt={"logo"}
                                                    className="nnSeal-size mt-2"
                                                />
                                            </Col>
                                            <Col md={10} className="mt-2 py-2">
                                                <h1 className="pb-5 fw-bold libre-baskerville-bold responsive-font">
                                                    Navajo Nation Jobs Apply Portal
                                                </h1>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="text-center">
                                    <p className="fs-3">
                                        {!isSignedIn && (
                                            <span className="border-bottom border-warning border-3 fw-bold libre-baskerville-regular">
                                                {" "}
                                                Welcome to the Apply Portal for
                                                the Navajo Nation.{" "}
                                            </span>
                                        )}
                                        {isSignedIn && (
                                            <span className="border-bottom border-warning border-3 fw-bold libre-baskerville-regular">
                                                {" "}
                                                Welcome {firstName} {lastName}{" "}
                                                to the Apply Portal for the
                                                Navajo Nation.{" "}
                                            </span>
                                        )}
                                    </p>
                                    <p className="fs-4 libre-baskerville-regular">
                                        We appreciate your visit and hope
                                        that we have a job that suits your
                                        interest and field! Start your
                                        career with the Navajo Nation by
                                        selecting one of the options below.
                                    </p>
                                </Row>
                                <Row>
                                    <Row className="text-center">
                                        <h3> Get Started:</h3>
                                    </Row>
                                    <Row className="justify-content-center mx-0">
                                        {!isSignedIn && (
                                            <>
                                                <NavigationBoxes
                                                    navTitle={"Job Search"}
                                                    navDescription={
                                                        "View available jobs listing. Find jobs nearby and begin applying!"
                                                    }
                                                    navButtonText={
                                                        "Search for jobs"
                                                    }
                                                    pageName={"/jobs"}
                                                />
                                                <NavigationBoxes
                                                    navTitle={"Create Account"}
                                                    navDescription={
                                                        "Tell us about yourself, create an account and upload employment information to make applying easy."
                                                    }
                                                    navButtonText={
                                                        "Create Account"
                                                    }
                                                    pageName={"/signup"}
                                                />
                                                <NavigationBoxes
                                                    navTitle={
                                                        "Returning Candidates"
                                                    }
                                                    navDescription={
                                                        "Continue applying or track the status of your application."
                                                    }
                                                    navButtonText={"Log In"}
                                                    pageName={"/signin"}
                                                />
                                            </>
                                        )}
                                        {isSignedIn && (
                                            <>
                                                <NavigationBoxes
                                                    navTitle={
                                                        "Looking for a Job?"
                                                    }
                                                    navDescription={
                                                        "View available job listing with the Navajo Nation and begin applying!"
                                                    }
                                                    navButtonText={
                                                        "Search for Jobs"
                                                    }
                                                    pageName={"/jobs"}
                                                />
                                                <NavigationBoxes
                                                    navTitle={
                                                        "View Application Status"
                                                    }
                                                    navDescription={
                                                        "Track the status of submitted applications here!"
                                                    }
                                                    navButtonText={
                                                        "Check Status"
                                                    }
                                                    pageName={"/application"}
                                                />
                                                    <NavigationBoxes
                                                        navTitle={
                                                            "Have any questions?"
                                                        }
                                                        navDescription={
                                                            "Here, you can explore some of the most frequently asked questions!"
                                                        }
                                                        navButtonText={
                                                            "View FAQ"
                                                        }
                                                        pageName={"/faq"}
                                                    />
                                            </>
                                        )}
                                    </Row>
                                </Row>
                            </Card.Body>
                        </Card>

                    </Col>
                </Row>
            </Container>
            <Container className="mt-3 mb-4">
                <Row className="text-center">
                    <h3> New to the Job Portal? <br></br>Watch how to sign up, create a profile and apply for a position:</h3>
                </Row>
                {isMobile && (
                    <Row>
                        <Ratio aspectRatio={'1x1'} >
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/KjjDlyC9Pj0?si=eGtB1dK-ojqhQZdh" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                        </Ratio>
                    </Row>)
                }
                {!isMobile && (
                    <Row>
                        <Ratio aspectRatio={'16x9'} >
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/KjjDlyC9Pj0?si=eGtB1dK-ojqhQZdh" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                        </Ratio>
                    </Row>)
                }
            </Container>
        </>
    );
};
